import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Login from './components/auth/Login';
import NuevaCuenta from './components/auth/NuevaCuenta';
import RecuperarPassword from './components/auth/RecuperarPassword';
import Resultados from './components/consultas/Resultados';
import { ResultadosDetalle } from './components/consultas/resultadosDetalle/ResultadosDetalle';
import Citas from './components/citas/Citas';
import Prospecto from './components/doctores/Prospecto';
import Pacientes from './components/doctores/Pacientes';
import Validador from './components/consultas/resultadosDetalle/Validador';

import AuthState from './context/autenticacion/authState';
import AlertaState from './context/alertas/alertaState';
import tokenAuth from './config/tokenAuth';
import ResultadoState from './context/resultados/resultadoState';
import ResultadoDetalleState from './context/resultadosDetalle/resultadoDetalleState';
import CitasState from './context/citas/citasState';
import ProspectosState from './context/doctores/prospectos/prospectoState';
import PacientesState from './context/doctores/pacientes/pacientesState';

import RutaPrivada from './components/rutas/RutaPrivada';

// Revisar si tenemos un token
const token = localStorage.getItem('token');
if(token) {
  tokenAuth(token);
}

function App() {
  return (
    <AuthState>
      <AlertaState>
        <ResultadoState>
          <ResultadoDetalleState>
            <CitasState>
              <ProspectosState>
                <PacientesState>
                  <Router>
                    <Switch>
                      <Route exact path="/" component={Login} />
                      <Route exact path="/registro" component={NuevaCuenta} />
                      <Route exact path="/password" component={RecuperarPassword} />
                      <RutaPrivada exact path="/resultados" component={Resultados} />
                      <Route exact path="/resultadosDetalle" component={ResultadosDetalle} />
                      <RutaPrivada exact path="/citas" component={Citas} />
                      <RutaPrivada exact path="/prospectos" component={Prospecto} />
                      <RutaPrivada exact path="/pacientes" component={Pacientes} />
                      <Route exact path="/validador/:oid/:id" component={Validador} />
                    </Switch>
                  </Router>
                </PacientesState>
              </ProspectosState>
            </CitasState>
          </ResultadoDetalleState>
        </ResultadoState>
      </AlertaState>
    </AuthState>
  );
}

export default App;
